import { styled, TextField } from "@mui/material";
export const StyledTextField = styled(TextField)(({ theme, width, disabled, background, multiline, label }) => ({
    maxWidth: width,
    width: "100%",
    ...(multiline ? {} : { height: "56px" }),
    "& .MuiInputBase-root": {
        position: "relative",
        paddingTop: label === "" ? '8px !important' : "auto",
        // Placeholder styles
        "&.MuiFilledInput-root": {
            borderRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: background || 'transparent',
            "&.Mui-focused": {
                border: `1px solid ${theme.palette.primary.main}`,
            },
            "&:before, &::after": {
                border: "none !important",
            }
        },
        "& .MuiFilledInput-input": {
            borderRadius: theme.shape.borderRadius,
        },
        "&::placeholder": {
            transition: theme.transitions.create(["transform", "font-size"], {
                duration: theme.transitions.duration.shortest,
            }),
            color: disabled ? theme.palette.text.disabled : "#00244D99", // Placeholder color
        },
        // Placeholder transformation on focus
        "&:focus-within::placeholder": {
            transform: "translateY(-16px)",
            fontSize: "12px",
            color: theme.palette.primary.main,
        },
        // Input field border styles
        "& .MuiOutlinedInput-notchedOutline": {
            border: disabled
                ? `1px solid #00244D33`
                : `1px solid ${theme.palette.edark.light}`,
        },
        // Input value color
        "& .MuiInputBase-input": {
            color: "#00244D", // Text value color
        },
    },
}));
